import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap} from "gsap";
import {XW2GameMode, XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";


export class TrashSymView extends PIXI.Container implements StageLayer {

    private symRemoveSpine: PIXI.spine.Spine;
    public isSkipped: boolean = false;


    constructor() {
        super();

        this.name = "TrashSymView";
        this.visible = false;
        this.init();
        this.onResize();
    }

    public buildTrashSplashSequence(currentLevel: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const levelcheck: number = JSON.parse(JSON.stringify(currentLevel));
        const screenDarkDuration: number = levelcheck + 1 !== 4 ? 0.05 : 1.5;
        const alphaValue: number = levelcheck + 1 !== 4 ? 0.80 : 1
        tl.add(XwaysHoarder2.darkOverlay.addOverlay(screenDarkDuration, alphaValue), 0);
        tl.add(this.showAnim(currentLevel), 0);
        tl.add(this.hideAnim(), ">");
        tl.add(XwaysHoarder2.darkOverlay.hideOverlay(0.1));

        return tl;
    }

    onResize(): void {
        if(NolimitApplication.isLandscape) {
            this.symRemoveSpine.scale.set(1, 1);
        }
        else {
            this.symRemoveSpine.scale.set(0.55, 0.55);
        }
    }

    showAnim(level: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.onResize();
            this.visible = true;
            this.symRemoveSpine.visible = true;
            this.alpha = 1;
            level + 1 === 4 ? this.symRemoveSpine.position.set(360, 380) : this.symRemoveSpine.position.set(400, 380);
        }, 0);

        if(level + 1 === 4) {

            switch (XwaysHoarder2.model.mode) {
                case XW2GameMode.FREESPIN:
                    tl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.BINGE_SPINS, XW2GameMode.FREESPIN));
                    break;
                case XW2GameMode.SUPER_FREESPIN:
                    tl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.BINGE_SPINS, XW2GameMode.SUPER_FREESPIN));
                    break;
                case XW2GameMode.NORMAL:
                    tl.add(XwaysHoarder2.transitionPlayer.playSpineTransition(XW2GameMode.BINGE_SPINS, XW2GameMode.SUPER_FREESPIN));

            }
            tl.add(() => {
                XwaysHoarder2.transitionPlayer.playSpineIdleLoop(XW2GameMode.BINGE_SPINS);
            }, 5.85);
            //tl.to(this.symRemoveSpine, {duration: 0.05, alpha: 1});
            tl.add([
                gsap.to(this.symRemoveSpine, {duration: 0.05, alpha: 1}),
                SpineGSAPWrapper.createTimelineForAnimation(this.symRemoveSpine, 0, `Level${level + 1}`,false),
                () => {
                    //SlotGame.keypadPlugin.setZeroBetSpinCounter(XwaysHoarder2.model.data.freespinsLeft);
                }
            ], 0.5);
            //tl.to(this.symRemoveSpine, {duration: 0.05, alpha: 1});
        }
        else {
            tl.to(this.symRemoveSpine, {duration: 0.05, alpha: 1});
            tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.symRemoveSpine, 0, `Level${level + 1}`,false));
        }

        switch(level + 1) {
            case 3:
                tl.add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCREAM_M6);
                }, "<");
                break;
            case 2:
                tl.add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCREAM_M5);
                }, "<");
                break;
            case 1:
                tl.add(() => {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.SCREAM_M4);
                }, "<");
                break;
        }

        if(level<3){
            tl.add(()=>{
                if(!this.isSkipped) {
                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.RADIATION_ANIMATION);
                }
            },"<");
        }else{
            tl.add(()=>{
                XwaysHoarder2Sound.fadeMusic(0, 100);
                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BINGE_INTRO);
                // Fade out sound
            },"<");
        }


        return tl;
    }

    hideAnim(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
         tl.to(this.symRemoveSpine, {duration: 0.001, alpha: 0});
        tl.add(() => {
            //XwaysHoarder2.keypadPlugin.setZeroBetSpinCounter(XwaysHoarder2.model.data.freespinsLeft);
            this.visible = false;
            this.symRemoveSpine.visible = false;
            this.alpha = 0;
        }, ">")

        return tl;
    }

    private init(): void {
        this.symRemoveSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SYMBOL_REMOVE));
        this.symRemoveSpine.visible = false;
        this.symRemoveSpine.alpha = 0;
        this.symRemoveSpine.position.set(360, 380);
        this.addChild(this.symRemoveSpine);
        this.alpha = 0;
        this.visible = false;


    }


}